import { connect } from "react-redux";
import Account from "./Account";
import { getUser } from '../../store/selectors/user.selector';

const mapStateToProps = (state) => { 
    let user = getUser(state);

    return { user };
 };

export default connect(mapStateToProps, null)(Account);